<template>
    <section class="py-12 relative">

        <div class="w-full flex flex-col md:flex-row flex-col-reverse md:flex-row gap-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center">
            <div class="w-full md:w-3/5">
                

                <div class="text-4xl font-headings mb-4 text-center md:text-left mt-12 md:mt-0">{{title}}</div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                    <div 
                        v-for="(feature, index) in appFeatures" 
                        :key="index" 
                        :class="[
                            'p-4 bg-white rounded-lg shadow-md cursor-pointer transition-all duration-200',
                            activeFeatureIndex === index ? 'border-2 border-primary-500 shadow-lg' : 'border-2 border-transparent hover:border-gray-200'
                        ]"
                        @click="selectFeature(index)">
                        <div class="font-semibold mb-1 leading-5">{{ feature.title }}</div>
                        <div class="text-sm text-gray-600">{{ feature.description }}</div>
                    </div>
                </div>
            </div>

            <div class="w-full md:w-2/5">
                <div class="left-1/2 md:ml-32 ml-14 w-2/3 md:w-[350px] z-30 pb-12 md:pb-0 "
                    style="aspect-ratio: 9/17; transform: rotate(0deg);">

                    <DeviceWrapper deviceType="phone" :width="100" :z="0" :x="0" :y="-8" :rotateOnScroll="false"
                        :imageSrc="appFeatures[selectedStep].image" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

import SectionHeader from '../../Layouts/SectionHeader.vue'
import DeviceWrapper from '../../DeviceWrapper.vue'

import eventAppImageMenu from '@/images/screenshots/app/theme-1/menu.png'

import appNotifications from '@/images/screenshots/app/theme-1/notifications.png'
import appFloorplans from '@/images/screenshots/app/theme-1/floorplans.png'
import appGamification from '@/images/screenshots/app/theme-1/leaderboard.png'
import appMeetings from '@/images/screenshots/app/theme-1/meetings2.png'
import appMessaging from '@/images/screenshots/app/theme-1/messages.png'
import appActivityFeed from '@/images/screenshots/app/theme-1/activityfeed.png'
import appSession from '@/images/screenshots/app/theme-1/session.png'
import appExhibitors from '@/images/screenshots/app/theme-1/exhibitors.png'
import appFeedback from '@/images/screenshots/app/theme-1/feedback.png'
import appContent from '@/images/screenshots/app/theme-1/content.png'
import appProfile from '@/images/screenshots/app/theme-1/my-profile.png'
import appQandA from '@/images/screenshots/app/theme-1/qanda.png'

const props = defineProps({
    subheader: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    }
})

const appFeatures = [
    {        
        title: 'Event Details',
        description: 'Access key event information in one central place.',
        image: eventAppImageMenu
    },
    
    {
        title: 'Push Notifications',
        description: 'Receive real-time updates and important announcements instantly.',
        image: appNotifications
    },
    {
        title: 'Submission & Feedback Forms',
        description: 'Collect feedback, surveys and attendee submissions easily.',
        image: appFeedback
    },
    {
        title: 'Floorplans',
        description: 'Navigate venues with interactive, easy-to-use maps.',
        image: appFloorplans
    },
    {
        title: 'Session Engagement',
        description: 'Participate in live polls, Q&A and discussions.',
        image: appQandA
    },
    {
        title: 'Gamification',
        description: 'Drive engagement with points, challenges and leaderboards.',
        image: appGamification
    },
    {
        title: 'Connections & Messaging',
        description: 'Message attendees and capture leads instantly.',
        image: appMessaging
    },
    {
        title: 'Activity Feed',
        description: 'Engage in a private event social feed.',
        image: appActivityFeed
    },
    {
        title: 'Meetings & Connections',
        description: 'Schedule meetings and connect with other attendees.',
        image: appMeetings
    },
    {
        title: 'Exhibitors & Sponsors',
        description: 'Explore companies, products and connect directly.',
        image: appExhibitors
    },
    
    {
        title: 'Schedules & Speakers',
        description: 'Browse sessions, speakers, abstracts and presentations.',
        image: appSession
    },
    
    {
        title: 'Documents',
        description: 'Access session files, brochures and event resources.',
        image: eventAppImageMenu
    },
    {        
        title: 'Bookmarks & Notes',
        description: 'Save favourites and add personal session notes.',
        image: eventAppImageMenu
    },
    {
        title: 'Content Pages',
        description: 'Create flexible pages tailored to your event.',
        image: appContent
    },
    {
        title: 'Manage Profile',
        description: 'Update profile and permissions. View In app badge. Download leads and notes.',
        image: appProfile
    }
]


const selectedStep = ref(0)
const activeFeatureIndex = ref(0)
const isRotationPaused = ref(false)
let rotationInterval = null
const ROTATION_INTERVAL_MS = 2000

const MOBILE_MAX_WIDTH = 768

function selectFeature(index) {
    if (window.innerWidth <= MOBILE_MAX_WIDTH) return

    activeFeatureIndex.value = index
    selectedStep.value = index
    isRotationPaused.value = true
    
    // Clear the interval if it exists
    if (rotationInterval) {
        clearInterval(rotationInterval)
        rotationInterval = null
    }
}

function startRotation() {
    if (rotationInterval) return
    
    rotationInterval = setInterval(() => {
        if (!isRotationPaused.value) {
            activeFeatureIndex.value = (activeFeatureIndex.value + 1) % appFeatures.length
            selectedStep.value = activeFeatureIndex.value
        }
    }, ROTATION_INTERVAL_MS)
}

onMounted(() => {
    startRotation()
})

onUnmounted(() => {
    if (rotationInterval) {
        clearInterval(rotationInterval)
    }
})
</script>